import Accordion from "../components/accordion.js";
import HorizontalTabs from "../components/horizontalTabs";
import CarouselCta from "../components/carouselCta";
import LogosMarquee from "../components/logosMarquee.js";
import TwoThreeCards from "../components/twoThreeCards";
import VerticalTabs from "../components/verticalTabs.js";
import AccordionWithVisuals from "../components/accordionWithVisuals.js";
import Testimonials from "../components/testimonials";
import VideoYoutube from "../components/videoYoutube.js";

export default {
    init() {
        // JavaScript to be fired on all pages
        console.log ('init plugins javascript');
         // init all accordions
        new Accordion();
        new HorizontalTabs();
        new CarouselCta();
        new TwoThreeCards();
        new Testimonials();
        new VideoYoutube();

        // Define Logos tag
        customElements.define('logos-marquee', LogosMarquee)
        // Define vertical tabs tag
        customElements.define('vertical-tabs', VerticalTabs)
        // Define accordion with visual tag
        customElements.define('accordion-with-visual', AccordionWithVisuals)
    },

    finalize() {
        console.log ('finalize plugins javascript');
    },
};
